// File upload constraints
export const ALLOWED_FILE_TYPES = [
	"image/jpeg",
	"image/png",
	"application/pdf",
] as const;

export const ALLOWED_FILE_EXTENSIONS = ".jpg,.jpeg,.png,.pdf";

export const FILE_TYPE_ERROR_MESSAGE =
	"Only JPG, PNG, and PDF files are allowed";

// Textarea constraints
export const TEXTAREA_LINE_HEIGHT = 24;
export const TEXTAREA_SINGLE_LINE_HEIGHT = 50;
export const TEXTAREA_MAX_LINES = 4;
export const TEXTAREA_MAX_HEIGHT =
	TEXTAREA_LINE_HEIGHT * TEXTAREA_MAX_LINES + 6; // 102px

// Recording
export const AUDIO_MIME_TYPE = "audio/webm";
export const AUDIO_FILE_NAME = "audio.webm";

// Analytics event names
export const ANALYTICS_EVENTS = {
	// AI Chat events
	CHAT_MESSAGE_SENT: "chat_message_sent",
	CHAT_MESSAGE_RECEIVED: "chat_message_received",
	CHAT_FILE_ATTACHED: "chat_file_attached",
	CHAT_FILE_REMOVED: "chat_file_removed",
	CHAT_VOICE_STARTED: "chat_voice_recording_started",
	CHAT_VOICE_STOPPED: "chat_voice_recording_stopped",
	CHAT_VOICE_TRANSCRIBED: "chat_voice_transcribed",
	CHAT_SUGGEST_CLICKED: "chat_suggest_clicked",
	CHAT_MESSAGE_COPIED: "chat_message_copied",
	CHAT_MESSAGE_READ_ALOUD: "chat_message_read_aloud",
	CHAT_MESSAGE_REPLY_CLICKED: "chat_message_reply_clicked",
	CHAT_QUESTION_BOOKMARKED: "chat_question_bookmarked",
	CHAT_ATTACHMENT_MENU_OPENED: "chat_attachment_menu_opened",
	CHAT_PHOTO_LIBRARY_CLICKED: "chat_photo_library_clicked",
	CHAT_TAKE_PHOTO_CLICKED: "chat_take_photo_clicked",
	CHAT_CHOOSE_FILES_CLICKED: "chat_choose_files_clicked",
	CHAT_SEND_CLICKED: "chat_send_clicked",
	CHAT_HISTORY_NEW_CHAT_CLICKED: "chat_history_new_chat_clicked",
	// Provider Chat events
	PROVIDER_CHAT_NO_PROVIDER_ASSIGNED: "chat_with_provider_no_provider_assigned",
	PROVIDER_CHAT_CONNECTED: "provider_chat_connected",
	PROVIDER_CHAT_MESSAGE_SENT: "provider_chat_message_sent",
	PROVIDER_CHAT_MESSAGE_RECEIVED: "provider_chat_message_received",
} as const;

// Question category types
export const QuestionCategory = {
	Legal: "legal",
	ComparisonsAndDilemmas: "comparisons-dilemmas",
	LifestylePreparation: "lifestyle-preparation",
	GettingStarted: "getting-started",
	Medical: "medical",
	EmotionalMentalHealth: "emotional-mental-health",
	FinancialPlanning: "financial-planning",
	DonorSurrogacyMatching: "donor-surrogacy-matching",
	Providers: "providers",
	TimelineReadiness: "timeline-readiness",
} as const;

// Category color mapping
export const CATEGORY_COLORS: Record<string, string> = {
	[QuestionCategory.Legal]: "#f03050", // Red/Pink - Legal matters
	[QuestionCategory.ComparisonsAndDilemmas]: "#ff9500", // Orange - Decision making
	[QuestionCategory.LifestylePreparation]: "#399c08", // Green - Lifestyle & wellness
	[QuestionCategory.GettingStarted]: "#3265f0", // Blue - Getting started
	[QuestionCategory.Medical]: "#7536ff", // Purple - Medical/treatment
	[QuestionCategory.EmotionalMentalHealth]: "#f03050", // Red/Pink - Emotional support
	[QuestionCategory.FinancialPlanning]: "#ff9500", // Orange - Financial
	[QuestionCategory.DonorSurrogacyMatching]: "#00c7be", // Teal - Donor/surrogacy
	[QuestionCategory.Providers]: "#7536ff", // Purple - Providers
	[QuestionCategory.TimelineReadiness]: "#3265f0", // Blue - Timeline planning
	default: "#3265f0", // Blue - Default fallback
} as const;
